<div id="account-status" class="clearfix">
  <div class="row">
    <div class="col">
      <a href="/">
        <svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 766.3 173.69">
          <defs>
            <style>
            .cls-1 {
              fill: #262626;
              stroke-width: 0px;
            }
            </style>
          </defs>
          <path
            class="cls-1"
            d="m274.6,27.71c-8-4.45-16.91-6.68-26.74-6.68s-19.17,2.16-27.23,6.49c-8.06,4.32-14.39,10.42-18.97,18.29-4.59,7.86-6.88,16.84-6.88,26.94v80.61h21.43v-39.84c2.62,2.12,5.46,3.97,8.55,5.53,7.14,3.61,15.11,5.41,23.89,5.41,9.7,0,18.48-2.23,26.35-6.68,7.86-4.46,14.02-10.65,18.48-18.58,4.45-7.93,6.68-16.74,6.68-26.44s-2.26-18.68-6.78-26.54-10.78-14.02-18.78-18.48Zm-4.92,67.44c-5.77,5.9-13.04,8.85-21.82,8.85s-16.48-2.95-22.31-8.85c-5.83-5.9-8.75-13.37-8.75-22.41s2.91-16.52,8.75-22.41c5.83-5.9,13.27-8.85,22.31-8.85s16.05,2.95,21.82,8.85c5.77,5.9,8.65,13.37,8.65,22.41s-2.88,16.51-8.65,22.41Z"
          />
          <path
            class="cls-1"
            d="m324.34,18.07c-4.06,0-7.41,1.28-10.03,3.83-2.62,2.56-3.93,5.74-3.93,9.54s1.31,6.98,3.93,9.53c2.62,2.56,5.96,3.83,10.03,3.83s7.4-1.28,10.03-3.83c2.62-2.56,3.93-5.73,3.93-9.53s-1.31-6.98-3.93-9.54c-2.62-2.56-5.97-3.83-10.03-3.83Z"
          />
          <rect class="cls-1" x="313.72" y="55.04" width="21.23" height="98.3" />
          <path
            class="cls-1"
            d="m427.46,59.07c-7.41-4.52-15.96-6.78-25.66-6.78s-18.74,2.2-26.35,6.59c-7.6,4.39-13.53,10.49-17.79,18.28-4.26,7.8-6.39,16.75-6.39,26.84s2.19,19.3,6.59,27.23c4.39,7.93,10.52,14.06,18.38,18.38,7.86,4.32,16.71,6.49,26.54,6.49,11.27,0,20.97-2.85,29.1-8.55,8.12-5.7,14.09-13.47,17.89-23.3h-22.41c-5.38,8.65-13.76,12.98-25.17,12.98-8.92,0-16.12-2.95-21.63-8.85-3.78-4.05-6.23-9.18-7.42-15.33h77.01c.4-2.75.59-5.77.59-9.04,0-9.7-2.03-18.48-6.09-26.35-4.07-7.86-9.8-14.06-17.2-18.58Zm-46.99,21.14c5.44-5.9,12.55-8.85,21.33-8.85s15.4,2.95,20.64,8.85c3.68,4.14,5.94,9.2,6.84,15.14h-56.16c1.16-6.01,3.59-11.07,7.34-15.14Z"
          />
          <path
            class="cls-1"
            d="m532.84,57.69c-6.75-3.6-14.32-5.41-22.71-5.41s-16.16,1.77-22.91,5.31c-6.75,3.54-12.03,8.62-15.83,15.24-3.8,6.62-5.7,14.25-5.7,22.91v57.61h21.82v-57.21c0-6.81,2.06-12.39,6.19-16.71,4.13-4.33,9.6-6.49,16.42-6.49s11.96,2.13,16.22,6.39c4.26,4.26,6.39,9.86,6.39,16.81v57.21h21.82v-57.61c0-8.65-1.94-16.25-5.8-22.81-3.87-6.55-9.18-11.63-15.93-15.24Z"
          />
          <path
            class="cls-1"
            d="m621.01,95.34l-16.71-1.97c-5.11-.52-8.75-1.7-10.91-3.54-2.16-1.83-3.24-4.39-3.24-7.67,0-3.67,1.6-6.49,4.82-8.45,3.21-1.97,7.9-2.95,14.06-2.95,12.19,0,18.61,4.39,19.27,13.17h20.84c-.13-9.7-3.87-17.4-11.21-23.1-7.34-5.7-16.84-8.55-28.51-8.55-12.45,0-22.28,2.75-29.49,8.26-7.21,5.5-10.81,12.98-10.81,22.41,0,8.39,2.59,15.14,7.77,20.25,5.18,5.11,12.55,8.26,22.12,9.44l18.28,2.16c4.72.52,7.99,1.61,9.83,3.24,1.83,1.64,2.75,3.96,2.75,6.98,0,3.93-1.64,7.01-4.91,9.24-3.28,2.23-8.06,3.34-14.35,3.34-7.08,0-12.32-1.08-15.73-3.24-3.41-2.16-5.24-5.47-5.5-9.93h-20.84c.13,9.96,3.9,17.73,11.3,23.3,7.4,5.57,17.6,8.36,30.57,8.36s22.48-2.88,29.69-8.65c7.21-5.77,10.81-13.3,10.81-22.61,0-17.3-9.96-27.13-29.88-29.49Z"
          />
          <path
            class="cls-1"
            d="m759.52,77.74c-4.52-7.93-10.78-14.15-18.78-18.68-8-4.52-16.84-6.78-26.54-6.78s-18.55,2.26-26.54,6.78c-7.99,4.52-14.25,10.75-18.77,18.68-4.52,7.93-6.78,16.75-6.78,26.44s2.26,18.29,6.78,26.15c4.52,7.86,10.78,14.09,18.77,18.68,7.99,4.59,16.84,6.95,26.54,7.08,9.7-.13,18.54-2.49,26.54-7.08,7.99-4.59,14.25-10.81,18.78-18.68,4.52-7.86,6.78-16.58,6.78-26.15s-2.26-18.51-6.78-26.44Zm-23.69,49.15c-5.64,5.97-12.85,8.95-21.63,8.95s-15.99-2.98-21.63-8.95c-5.64-5.96-8.45-13.53-8.45-22.71s2.82-16.94,8.45-22.91c5.63-5.96,12.84-8.94,21.63-8.94s15.99,2.98,21.63,8.94c5.63,5.97,8.45,13.6,8.45,22.91s-2.82,16.75-8.45,22.71Z"
          />
          <path
            class="cls-1"
            d="m28.05,25.7l-17.95,10.37C3.84,39.67,0,46.35,0,53.55v66.68c0,7.22,3.84,13.87,10.1,17.47l27.68,15.98V63.72l28.05-16.21L28.05,25.7Z"
          />
          <path
            class="cls-1"
            d="m145.72,36.06h-.03L87.94,2.7c-6.25-3.6-13.95-3.6-20.18,0l-27.68,15.98,77.93,44.97v32.41l37.78-21.82v-20.73h0c0-7.19-3.84-13.86-10.07-17.46Z"
          />
          <path
            class="cls-1"
            d="m49.77,116.99h0v43.64l17.95,10.37c6.26,3.6,13.93,3.6,20.18,0l57.76-33.36c6.25-3.6,10.1-10.28,10.1-17.47v-31.97l-77.92,44.99-28.06-16.2Z"
          />
        </svg>
      </a>

      <div id="parent-nav">
        @for (section of getSections(); track section) {
        <div
          ngbDropdown
          #myDrop="ngbDropdown"
          (mouseenter)="$event.stopPropagation(); myDrop.open();"
          (mouseleave)="$event.stopPropagation(); myDrop.close();"
          class="item"
          [ngClass]="{active: section.display.selected}"
        >
          @let hasAccess = hasChildWithRoleAccess(section);

          <a
            ngbDropdownToggle
            class="btn top-link"
            [class.disabled]="!hasAccess"
            [ngbTooltip]="!hasAccess ? 'No access' : ''"
            (click)="hasAccess ? gotoURL(section.display) : null"
          >
            @if (section.display.selected) {
            <div class="activeParentMarker"></div>
            } @if (!!section.display.icon) {
            <fa-icon [size]="'lg'" [icon]="section.display.icon"></fa-icon>
            }
            <span> {{ getCategoryName(section) }} </span>
          </a>
          <div ngbDropdownMenu [hidden]="!canDropDown(section.children).length">
            @for (link of canDropDown(section.children); track link) { @if (hasRoleAccess(link)) {
            <div
              ngbDropdown="ngbDropdown"
              #childDrop="ngbDropdown"
              (mouseenter)="$event.stopPropagation(); childDrop.open();"
              (mouseleave)="$event.stopPropagation(); childDrop.close();"
              class="dropdownSubmenu"
            >
              <a ngbDropdownItem (click)="gotoURL(link)">
                <div class="activeItemMarker"></div>
                {{ link.name }}
              </a>
              <div ngbDropdownMenu [hidden]="!canDropDown(link.children).length">
                @for (subSection of canDropDown(link.children); track subSection) {
                <a ngbDropdownItem (click)="gotoURL(subSection)">
                  <div class="activeItemMarker"></div>
                  {{ subSection.name }}
                </a>
                }
              </div>
            </div>
            } @else {
            <span class="dropdown-item disabled" [ngbTooltip]="'No access'">
              <div class="activeItemMarker"></div>
              {{ link.name }}
            </span>
            } }
          </div>
        </div>
        }
      </div>

      <div id="account" class="float-end me-3">
        <div ngbDropdown class="item">
          <button class="btn btn-account p-r-0" ngbDropdownToggle>
            <!-- <div class="profile-img"></div> -->
            @if (profile) {
            <div class="profile-name">{{ profile.email }}</div>
            }
          </button>
          <div ngbDropdownMenu placement="bottom" aria-labelledby="dropdownMenu1">
            <a
              class="dropdown-item"
              href="https://pienso.atlassian.net/wiki/spaces/usermanual/overview"
              target="_blank"
            >
              User Manual
            </a>
            <hr />
            <a
              class="dropdown-item mb-0"
              href="https://pienso.atlassian.net/servicedesk/customer/portals"
              target="_blank"
            >
              <i class="icon icon-help"></i>
              Support
            </a>
            <hr />
            <button class="dropdown-item mb-3" (click)="onLogout()">
              <i class="icon icon-power-off"></i>
              Log Out
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
